const KEY_STORE = {
    COVALENT_KEY: `ckey_cd35e13c07934ad7ba2dff18f49`,
    ALCHEMY_KEY: `N4cycfbybQOPGawxXOgXlAVcv4ZQ-JQS`,
    RAMP_TEST: `j4z5gn7eh7uvbdgpd7c7wgkq4msuqrgs4xq4jutv`,
    RAMP_PRODUCTION: `j4z5gn7eh7uvbdgpd7c7wgkq4msuqrgs4xq4jutv`
}

export default KEY_STORE